import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LoggerService} from '../../logging/services/logger.service';
import {LogLevel} from '../../logging/data/logLevel';
import {LogSourceType} from '../../logging/data/logSourceType';
import {LogSource} from '../../logging/data/logSource';

@Component({
  selector: 'w-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
  @Input() width: 'full' | 'contain';
  @Input() label: string;
  @Input() icon: string;
  @Output() action: EventEmitter<void> = new EventEmitter<void>();

  constructor(private loggingService: LoggerService) { }

  ngOnInit(): void {
  }

  onClick() {
    this.action.emit();
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.ButtonComponent, 'Clicked button ' + this.label);
  }
}
